import { Component } from 'react';
import { T, COMMON } from '../../common/js/i18n';

interface Props {
    onClose?: () => void;
}

interface State {
}

export default class DataHelp extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {};
    }
    render() {
        return (
            <div style={{ padding: "0.5em" }}>
                {T({
                    en: "The data is in JSON format. Please note that the attributes in JSON format must be enclosed in double quotations.",
                    zh: "数据是json格式，注意json格式的属性必须加双引号。"
                })}
                <div style={{ textAlign: "center", paddingTop: '0.5em' }}>
                    <button type="button" className="btn" onClick={() => {
                        if (this.props.onClose) {
                            this.props.onClose();
                        }
                    }}>{T(COMMON.CLOSE)}</button>
                </div>
            </div>
        );
    }
}
